export default function useDownloadFile() {
    const onDownloadFile = (data, fileName, fileType) => {
        const url = window.URL.createObjectURL(new Blob(["\ufeff", data], { type: 'text/csv;charset=utf-8' }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName + fileType);
        document.body.appendChild(link);
        link.click();
    }

    return {
        onDownloadFile
    }
}
